export default __webpack_public_path__ + "static/media/image-chair-algo-lima-04-l-w@3x.9b558b73.png";